export const getYear = state => state.reportDriverCosts.getIn(['list', 'year'])

export const getData = state => state.reportDriverCosts.getIn(['list', 'data'])
export const getFetching = state => state.reportDriverCosts.getIn(['list', 'fetching'])
export const getError = state => state.reportDriverCosts.getIn(['list', 'error'])

export const getDetailsData = state => state.reportDriverCosts.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportDriverCosts.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportDriverCosts.getIn(['details', 'error'])
